import ChartParametersFormatter from '../../parametersFormatters/ChartParametersFormatter'
import {ReportChartType} from '../../../constants'
import messageResource from '../../../../messageResource'

export default class ChartPDFParametersFormatter extends ChartParametersFormatter {
    init({selectorsData, dateFormat, ugrEnabled, tzgEnabled, reportAuthorizationInfo, reportParamsStringBuilderConstructor}) {
        super.init(
            {
                selectorsData: selectorsData,
                dateFormat: dateFormat,
                ugrFeatureEnabled: ugrEnabled,
                tzgFeatureEnabled: tzgEnabled,
                reportAuthorizationInfo: reportAuthorizationInfo,
                reportParamsStringBuilderConstructor: reportParamsStringBuilderConstructor
            }
        )
        return this
    }

    formatGrandTotalValueType(chartTypeValue) {
        switch (chartTypeValue) {
            case ReportChartType.PTO_BALANCE:
                if (SystemSettings.showPTOInHours) {
                    return messageResource.getMessage('report.chart_pdf.grand_total_hours')
                } else {
                    return messageResource.getMessage('report.chart_pdf.grand_total_days')
                }
            case ReportChartType.SICK_DAYS_BALANCE:
                if (SystemSettings.showSickInHours) {
                    return messageResource.getMessage('report.chart_pdf.grand_total_hours')
                } else {
                    return messageResource.getMessage('report.chart_pdf.grand_total_days')
                }
            case ReportChartType.TOTAL_WORKING_HOURS:
            case ReportChartType.APPROVED_WORKING_HOURS:
            case ReportChartType.LEAVE_HOURS:
            case ReportChartType.OVERTIME_HOURS:
                return messageResource.getMessage('report.chart_pdf.grand_total_hours')
            case ReportChartType.COST_OF_WORK:
            case ReportChartType.BILLABLE_AMOUNTS:
                return messageResource.getMessage('report.chart_pdf.grand_total_amount')
        }
    }

    formatGrandTotalPostfix(chartTypeValue) {
        switch (chartTypeValue) {
            case ReportChartType.PTO_BALANCE:
            case ReportChartType.SICK_DAYS_BALANCE:
                return ''
            case ReportChartType.TOTAL_WORKING_HOURS:
            case ReportChartType.APPROVED_WORKING_HOURS:
            case ReportChartType.LEAVE_HOURS:
            case ReportChartType.OVERTIME_HOURS:
                return messageResource.getMessage('common.mh')
            case ReportChartType.COST_OF_WORK:
            case ReportChartType.BILLABLE_AMOUNTS:
                return SystemSettings.currencySign
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/reports/charts/pdfgenerator/formatters/ChartPDFParametersFormatter.js